import apiClient from "./client";

export function createCustomer(data) {
  return apiClient.post("/admin/customers", data).then((r) => r.data);
}

export function getCustomers() {
  return apiClient.get("/admin/customers").then((r) => r.data);
}

export function getCustomerAdoption(params = {}) {
  return apiClient.get("/admin/adoption", { params }).then((r) => r.data);
}

export function updateCustomer(id, data) {
  return apiClient.put(`/admin/customers/${id}`, data);
}

export function updateCustomerModules(id, modules) {
  return apiClient.put(`/admin/customers/${id}/modules`, modules);
}

export function deleteCustomer(id) {
  return apiClient.delete(`/admin/customers/${id}`).then((r) => r.data);
}

export function getCustomerUsers(customerId) {
  return apiClient.get(`/admin/customers/${customerId}/users`).then((r) => r.data);
}

export function sendPasswordResetEmail(userId) {
  return apiClient.post(`/admin/users/${userId}/send-reset-email`);
}

export function setUserPassword(userId, newPassword) {
  return apiClient.post(`/admin/users/${userId}/set-password`, { newPassword });
}

export function addUserToCustomer(customerId, data) {
  return apiClient.post(`/admin/customers/${customerId}/users`, data).then((r) => r.data);
}

export function deleteUser(userId) {
  return apiClient.delete(`/admin/users/${userId}`).then((r) => r.data);
}

export function impersonate(userId, returnUrl) {
  return apiClient.post("/admin/impersonate", { userId, returnUrl }).then((r) => r.data);
}

export function stopImpersonate() {
  return apiClient.post("/admin/stop-impersonate").then((r) => r.data);
}

export function getImpersonationStatus() {
  return apiClient.get("/admin/impersonation-status").then((r) => r.data);
}
